import { Component, Input, Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '@app/core';
import { QuestionCollectionCategoryEnum } from '@app/shared/common/enums';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent {
  @Input() barData: any[] = [];
  @Input() showPercentage: boolean = true;
  @Input() stepType: any;

  QuestionCollectionCategoryEnum = QuestionCollectionCategoryEnum;

}

@Pipe({ name: 'customTranslate', pure: true })
export class CustomTranslatePipe implements PipeTransform {
  constructor(private loc: LocalizationService) {}

  transform(key: string, params?: any): string {
    if (!key) return '';
    let text = this.loc.translateTextWithCustomList(key);

    if (params && typeof params === 'object') {
      Object.keys(params).forEach(paramKey => {
        const placeholder = `{{${paramKey}}}`;
        text = text.replace(placeholder, params[paramKey]);
      });
    }
    
    return text;
  }
}